import { useState } from "react";
import { api } from "./api";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useEffect } from "react";
import FooterLogo from "./FooterLogo";

export default function Home() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLogoVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post(`/login`, { username, password });
      const { token, passwordChangeRequired } = res.data;

      sessionStorage.setItem("token", token);
      sessionStorage.setItem("username", username);
      sessionStorage.setItem("password", password);

      if (passwordChangeRequired) {
        navigate("/change-password");
      } else {
        setStatusMessage("Login successful. Redirecting...");
        setTimeout(() => navigate("/patients"), 1000);
      }
    } catch (err) {
      if (
        !err.response ||
        err.code === "ERR_BAD_RESPONSE" ||
        err.status === 504 ||
        err.message.includes("504")
      ) {
        setError("Server is unreachable. Please try again later.");
      } else {
        const status = err.response.status;
        const msg = err.response.data?.message;

        if (status === 500) {
          setError("Server error. Please try again later.");
        } else if (msg === "User locked") {
          setError("User is locked. Contact admin.");
        } else {
          setError("Invalid username or password.");
        }
      }
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `radial-gradient(circle at top left, #A8A8A8, #8C8C8C, #85D3DE, #8DDFEB)`,
      }}
    >
      <div className="backdrop-blur-md bg-white/30 p-8 rounded-xl shadow-2xl w-full max-w-sm border border-white/50">
        <img
          src="/InfoMedi_logo.png"
          alt="InfoMedi Logo"
          className={`w-50 mx-auto mb-6 transform transition-all duration-1000 ease-out
    ${
      logoVisible
        ? "opacity-100 translate-y-0 scale-100 pulse-glow hover:scale-110 hover:drop-shadow-xl"
        : "opacity-0 -translate-y-6 scale-75"
    }`}
        />

        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Login
        </h2>

        {statusMessage && (
          <div className="text-green-900 text-sm mb-3 text-center">
            {statusMessage}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <div className="relative mb-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="w-full p-3 border border-gray-300 rounded-lg pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="absolute right-3 top-3 text-gray-600 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {error && <div className="text-red-900 text-sm mb-2">{error}</div>}

          <button
            type="submit"
            className="w-full py-3 mt-2 rounded-lg text-white font-semibold 
             bg-gradient-to-r from-gray-400 to-blue-800 
             hover:from-blue-600 hover:to-gray-700 
             transition-all duration-300 shadow-md"
          >
            Login
          </button>
        </form>
      </div>
      <FooterLogo />
    </div>
  );
}
